module.exports = __webpack_public_path__ + "static/media/4.9c8c9295.svg";